import { render, staticRenderFns } from "./AthleteCoachedItem.vue?vue&type=template&id=6042c649&"
import script from "./AthleteCoachedItem.vue?vue&type=script&lang=js&"
export * from "./AthleteCoachedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports